import { RiPercentLine } from '@remixicon/react';
import { Card, CardContent } from '@components/ui/Card';

const QuoteRatioCard = ({ closedTrips = 0, totalQuotes = 0 }) => {
  const ratio = totalQuotes > 0 ? Math.round((closedTrips / totalQuotes) * 100) : 0;

  return (
    <Card className="overflow-hidden !rounded-3xl !border !border-gray-100 !shadow-none">
      <CardContent className="p-4">
        <div className="text-xs text-gray-500 mb-1">Quote-to-Closed Trip Ratio</div>
        <div className="flex justify-between items-center">
          <div>
            <div className="text-3xl font-medium text-gray-900">{ratio}%</div>
            <div className="text-sm text-gray-500">
              {closedTrips} closed trips / {totalQuotes} quotes sent
            </div>
          </div>
          <div className="w-10 h-10 bg-purple-50 rounded-full flex items-center justify-center">
            <RiPercentLine className="w-5 h-5 text-pink-400" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuoteRatioCard;
